import { render, staticRenderFns } from "./PhotoDocCapture.vue?vue&type=template&id=4b8064f1&scoped=true"
import script from "./PhotoDocCapture.vue?vue&type=script&lang=js"
export * from "./PhotoDocCapture.vue?vue&type=script&lang=js"
import style0 from "./PhotoDocCapture.vue?vue&type=style&index=0&id=4b8064f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8064f1",
  null
  
)

export default component.exports